import { ENDPOINTS as AUTH_ENDPOINTS } from '@iziping/common';

export const QUERY_CACHE = {
    RESET_PASSWORD_LINK: 'RESET_PASSWORD_LINK',
    TOURNAMENTS: 'TOURNAMENTS',
    TOURNAMENT: 'TOURNAMENT',
    CLUBS: 'CLUBS',
    CLUB: 'CLUB',
    PLAYER: 'PLAYER',
    HEAT: 'HEAT',
    TOURNAMENT_REGISTRATIONS: 'TOURNAMENTS_REGISTRATIONS',
    HEAT_REGISTRATIONS: 'HEAT_REGISTRATIONS',
    HEATS_TO_REGISTER: 'HEATS_TO_REGISTER',
    CREATE_TOURNAMENT_REGISTRATION: 'CREATE_TOURNAMENT_REGISTRATION',
    REMOVE_TOURNAMENT_REGISTRATION: 'REMOVE_TOURNAMENT_REGISTRATION',
    HEAT_NOT_REGISTERED: 'HEAT_NOT_REGISTERED',
    CREATE_HEAT_REGISTRATION: 'CREATE_HEAT_REGISTRATION',
    REMOVE_HEAT_REGISTRATION: 'REMOVE_HEAT_REGISTRATION',
    COMPUTE_SEEDS: 'COMPUTE_SEEDS',
    LAUNCH_HEAT: 'LAUNCH_HEAT',
    CANCEL_HEAT: 'CANCEL_HEAT',
    GET_HEAT: 'GET_HEAT',
    GET_HEAT_BRACKET: 'GET_HEAT_BRACKET',
    GET_HEATS_FOR_TOURNAMENT: 'GET_HEATS_FOR_TOURNAMENT',
    PLAYER_SUMMARY: 'PLAYER_SUMMARY',
    PLAYERS_LIST: 'PLAYERS_LIST',
    GROUPS: 'GROUPS',
    MATCH: 'MATCH',
    BRACKET: 'BRACKET',
    MATCHES_SEARCH_PENDING: 'MATCHES_SEARCH_PENDING',
    MATCHES_SEARCH_IN_PROGRESS: 'MATCHES_SEARCH_IN_PROGRESS',
    MATCHES_SEARCH_FINISHED: 'MATCHES_SEARCH_FINISHED',
    MATCHES_BUSY_PLAYERS: 'MATCHES_BUSY_PLAYERS',
    MATCHES_AVAILABLE_TABLES: 'MATCHES_AVAILABLE_TABLES',
    PLAYER_MATCHES_LIST: 'PLAYER_MATCHES_LIST',
    MATCH_LAUNCH: 'MATCH_LAUNCH',
    MATCH_STANDBY: 'MATCH_STANDBY',
    MATCH_FINISH: 'MATCH_FINISH',
    MATCH_MODIFY: 'MATCH_MODIFY',
    TABLES_STATISTICS: 'TABLES_STATISTICS',
    CLUBS_STATISTICS: 'CLUBS_STATISTICS',
    PLAYERS_STATISTICS: 'PLAYERS_STATISTICS',
    METRICS_STATISTICS: 'METRICS_STATISTICS',
    PLAYERS_RANGE_STATISTICS: 'PLAYERS_RANGE_STATISTICS',
    PLAYERS_BY_AGE_STATISTICS: 'PLAYERS_BY_AGE_STATISTICS',
    PLAYER_RANKINGS_BY_HEAT: 'PLAYER_RANKINGS_BY_HEAT',
    HEATS_RESULTS: 'HEATS_RESULTS',
    SURVEY_TEMPLATE: 'SURVEY_TEMPLATE',
    SAVE_SURVEY_TEMPLATE: 'SAVE_SURVEY_TEMPLATE',
    DELETE_SURVEY_TEMPLATE: 'DELETE_SURVEY_TEMPLATE',
    SEND_SURVEY: 'SEND_SURVEY',
    SURVEY_RESULTS: 'SURVEY_RESULTS',
    PRE_REGISTRATIONS: 'PRE_REGISTRATIONS',
    PRE_REGISTRATIONS_LIST: 'PRE_REGISTRATIONS_LIST',
    EDIT_PRE_REGISTRATIONS: 'EDIT_PRE_REGISTRATIONS',
    CREATE_PRE_REGISTRATION: 'CREATE_PRE_REGISTRATION',
    REGISTRATION_CONFIRMATION: 'REGISTRATION_CONFIRMATION',
    DELETE_REGISTRATION: 'DELETE_REGISTRATION',
    CONVERT_PRE_REGISTRATIONS: 'CONVERT_PRE_REGISTRATIONS',
    EXPORT_PRE_REGISTRATIONS: 'EXPORT_PRE_REGISTRATIONS',
    SYNCHRO_FFTT: 'SYNCHRO_FFTT',
    TOURNAMENT_MEMBERS: 'TOURNAMENT_MEMBERS',
    TOURNAMENT_TABLES: 'TOURNAMENT_TABLES',
    TOURNAMENT_CONFIG: 'TOURNAMENT_CONFIG',
    TOURNAMENT_EMAIL_CONFIG: 'TOURNAMENT_EMAIL_CONFIG',
    TOURNAMENT_PRE_REGISTRATION_CONFIG: 'TOURNAMENT_PRE_REGISTRATION_CONFIG',
    SAVE_PRE_REGISTRATION_CONFIG: 'SAVE_PRE_REGISTRATION_CONFIG',
    DELETE_PRE_REGISTRATION_CONFIG: 'DELETE_PRE_REGISTRATION_CONFIG',
    UPLOAD_TOURNAMENT_RESOURCE: 'UPLOAD_TOURNAMENT_RESOURCE',
    DELETE_TOURNAMENT_RESOURCE: 'DELETE_TOURNAMENT_RESOURCE',
    USER_SETTINGS: 'USER_SETTINGS',
    SAVE_USER_SETTINGS: 'SAVE_USER_SETTINGS',
    UPLOAD_USER_LOGO: 'UPLOAD_USER_LOGO',
    DELETE_USER_LOGO: 'DELETE_USER_LOGO',
};

export const ENDPOINTS = {
    ...AUTH_ENDPOINTS,
    tournamentViewToken: (id: number) => `/api/tournaments/${id}/view-token`,
    revokeViewToken: (id: number) => `/api/tournaments/${id}/view-token`,
    player: (id: number) => `/api/players/${id}`,
    players: `/api/players`,
    searchPlayersByTerm: (term: string) => `/api/players/search?term=${term}`,
    tournaments: `/api/tournaments`,
    tournament: (id: number) => `/api/tournaments/${id}`,
    tournamentTables: (id: number) => `/api/tournaments/${id}/tables`,
    tournamentTable: (id: number, tableId: number) => `/api/tournaments/${id}/tables/${tableId}`,
    tournamentTableToggle: (id: number, tableId: number) => `/api/tournaments/${id}/tables/${tableId}/toggle`,
    tournamentTablesResize: (id: number) => `/api/tournaments/${id}/tables/resize`,
    tournamentConfig: (id: number) => `/api/tournaments/${id}/config`,
    tournamentEmailConfig: (id: number) => `/api/tournaments/${id}/config/email`,
    tournamentEmailPreview: (id: number, lang: string) => `/api/tournaments/${id}/config/email/preview?lang=${lang}`,
    tournamentEmailPreviewSend: (id: number, lang: string) =>
        `/api/tournaments/${id}/config/email/preview/send?lang=${lang}`,
    tournamentRegistrations: (id: number) => `/api/tournaments/${id}/registrations`,
    tournamentRegisterPlayer: (id: number, playerId: string) => `/api/tournaments/${id}/registrations/${playerId}`,
    removeTournamentRegistration: (id: number, registrationId: number) =>
        `/api/tournaments/${id}/registrations/${registrationId}`,
    clubs: `/api/clubs`,
    club: (id: number) => `/api/clubs/${id}`,
    heat: (id: number) => `/api/heats/${id}`,
    heats: `/api/heats`,
    updateSeeds: (id: number) => `/api/heats/${id}/update-seeds`,
    clubsSearch: (term: string) => `/api/clubs/search?term=${encodeURIComponent(term)}`,
    heatsTournament: (id: number) => `/api/heats/tournament/${id}`,
    heatRegistrations: (heatId: number) => `/api/heats/${heatId}/registered`,
    heatsToRegister: (tournamentId: number) => `/api/tournaments/${tournamentId}/find-to-register`,
    findPlayersToRegister: (heatId: string) => `/api/heats/${heatId}/not-registered`,
    registerToHeat: (id: number) => `/api/heats/${id}/register`,
    removeFromHeat: (id: number, registrationId: number) => `/api/heats/${id}/registration/${registrationId}`,
    computeSeeds: (id: string) => `/api/heats/${id}/compute-seeds`,
    launchHeat: (id: string) => `/api/heats/${id}/launch`,
    cancelHeat: (id: string) => `/api/heats/${id}/cancel`,
    playerSummary: (id: number, playerId: string) => `/api/tournaments/${id}/players/${playerId}`,
    searchFFTT: (licence: string) => `/api/fftt/search/licence/${licence}`,
    synchroFFTT: (licence: string) => `/api/players/synchronize/${licence}`,
    getGroups: (heatId: number) => `/api/matches/groups/${heatId}`,
    getBracket: (heatId: number) => `/api/matches/bracket/${heatId}`,
    getFinalBracketForHeat: (heatId: number) => `/api/heats/${heatId}/bracket`,
    searchMatchesByStatus: `/api/matches/search`,
    searchMatchesPending: `/api/matches/pending`,
    searchFinishedMatches: `/api/matches/finished`,
    findBusyPlayers: `/api/matches/busy-players`,
    findAvailableTables: `/api/matches/available-tables`,
    getMatch: (matchId: number) => `/api/matches/${matchId}`,
    getMatchDetail: (matchId: number) => `/api/matches/${matchId}/detail`,
    launchMatch: (matchId: number) => `/api/matches/${matchId}/launch`,
    standByMatch: (matchId: number) => `/api/matches/${matchId}/stand-by`,
    finishMatch: (matchId: number) => `/api/matches/${matchId}/finish`,
    modifyMatch: (matchId: number) => `/api/matches/${matchId}/modify`,
    findPlayerMatches: `/api/matches/player`,
    downloadMatchToPrint: (matchId: number) => `/api/matches/print/${matchId}`,
    downloadSelectedMatchesToPrint: `/api/matches/print`,
    tablesStatistics: (tournamentId: number) => `/api/statistics/${tournamentId}/tables`,
    statisticsClubs: (tournamentId: number) => `/api/statistics/${tournamentId}/clubs`,
    statisticsPlayers: (tournamentId: number) => `/api/statistics/${tournamentId}/players`,
    statisticsMetrics: (tournamentId: number) => `/api/statistics/${tournamentId}/metrics`,
    statisticsPlayersRange: (tournamentId: number) => `/api/statistics/${tournamentId}/players-range`,
    statisticsPlayersByAge: (tournamentId: number) => `/api/statistics/${tournamentId}/players-by-age`,
    heatsResults: (tournamentId: number) => `/api/tournaments/${tournamentId}/rankings-by-heat`,
    preRegistrationsList: (tournamentId: number) => `/api/registrations/tournament/${tournamentId}`,
    convertPreRegistration: (tournamentId: number) => `/api/tournaments/${tournamentId}/convert-registrations`,
    provisionalRegistration: (tournamentUUID: string) =>
        `/api/registrations?tournamentUUID=${encodeURIComponent(tournamentUUID)}`,
    provisionalEditRegistration: (tournamentUUID: string, registrationId: string) =>
        `/api/registrations/${registrationId}?tournamentUUID=${encodeURIComponent(tournamentUUID)}`,
    registrationConfirmation: (registrationId: string) => `/api/registrations/confirmation/${registrationId}`,
    deleteRegistration: (registrationId: string) => `/api/registrations/${registrationId}`,
    exportPreRegistrations: (tournamentId: number) => `/api/tournaments/export/${tournamentId}`,
    sendEmailsToPlayers: (id: number) => `/api/tournaments/${id}/send-emails-to-players`,
    preRegistrationConfig: (id: number) => `/api/tournaments/${id}/config/pre-registration`,
    tournamentResource: (id: number, type: string) => `/api/tournaments/${id}/config/resources/${type}`,
    tournamentMembers: (id: number) => `/api/tournaments/${id}/members`,
    tournamentMember: (id: number, userId: number) => `/api/tournaments/${id}/members/${userId}`,
    userSettings: '/api/users/me/settings',
    userSettingsLogo: '/api/users/me/settings/logo',
    surveyTemplate: (id: number) => `/api/tournaments/${id}/survey`,
    surveySend: (id: number) => `/api/tournaments/${id}/survey/send`,
    surveyResults: (id: number) => `/api/tournaments/${id}/survey/results`,
    surveyPublic: (token: string) => `/api/survey/${token}`,
    surveyExport: (id: number) => `/api/tournaments/${id}/survey/export`,
};
